Vendd.Scripts.load(function () {

    var $form = $('.x-registration-b2b-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    importEmailForRegistration();

    formData = {
        companyName: "",
        occupation: "",
        TaxAgency: $('select[name="TaxAgency"]').val() || "",
        taxidentifier: "",
        officerName: "",
        vatstatus: 0,
        email: $('input[name="email"]').val() || "",
        emailConfirmation: "",
        username: "",

        town: "",
        address: "",
        number: "",
        postalCode: "",
        phone: "",
        password: "",
        passwordConfirmation: "",

        storesNumber: "",
        phoneTwo: "",
        mobile: "",
        fax: "",
        siteUrl: "",
        message: "",

        newsletter: false,
        reCaptchaCode: "",
        redirectUrl: $form.data('redirect') || "",
        acceptTerms: false,

        store: "",
        CompanyCategory: "",
        OpeningHours: "",
        area: "",
        prefecture: "",
        officerLastName: "",
        officerPosition: ""
    };

    var useEmailAsLoginName = $form.data('useemailasloginname').toString().toLowerCase() === 'true';

    // reCAPTCHA
    var captchaWidgetId;
    var captchaId = "registrationCaptcha";
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.error-recaptcha').hide();
            res = true;
        } else {
            $captchaContainer.find('.error-recaptcha').show();
        }

        return res;
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;

        if (response.success && response.code === "Registration_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-content', $form).hide();

            form.removeRecaptcha();

            $('.js-success', $form).show();
            $('html,body').animate({
                scrollTop: $('.js-success', $form).offset().Top - 100
            }, 300);
            $('input[name="password"]', $form).val("");
            $('input[name="passwordConfirmation"]', $form).val("");
        } else {
            if (response.code === 'Registration_EmailExists') {
                $('.js-error', $form).hide();
                $('.js-exists', $form).show();
                $('html,body').animate({
                    scrollTop: $('.js-exists', $form).offset().Top - 100
                }, 300);
                $('input[name="password"]', $form).val("");
                $('input[name="passwordConfirmation"]', $form).val("");

            } else {
                $('.js-exists', $form).hide();
                $('.js-error', $form).show();

                $('.js-error', $form).show();
                $('html,body').animate({
                    scrollTop: $('.js-error', $form).offset().Top - 100
                }, 300);
                $('input[name="password"]', $form).val("");
                $('input[name="passwordConfirmation"]', $form).val("");
            };

            form.resetRecaptcha();
        };
    };

    form.onFailure = function (envelope) {
        form.hideLoader();

        $('.js-exists-error', $form).hide();
        $('.js-error', $form).show();

        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");
    };

    form.submit = function () {
        form.loading(true);

        formData.vatstatus = $('select[name="vatstatus"]').val();
        formData.newsletter = $('#chkNewsletter').prop("checked");
        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.B2BRegister(
            formData.companyName,
            formData.occupation,
            formData.TaxAgency,
            formData.taxidentifier,
            formData.officerName,
            formData.vatstatus,
            formData.email,
            formData.emailConfirmation,
            formData.username,
            formData.town,
            formData.address,
            formData.number,
            formData.postalCode,
            formData.phone,
            formData.password,
            formData.passwordConfirmation,
            formData.storesNumber,
            formData.phoneTwo,
            formData.mobile,
            formData.fax,
            formData.siteUrl,
            formData.store,
            formData.CompanyCategory,
            formData.OpeningHours,
            formData.area,
            formData.prefecture,
            formData.officerLastName,
            formData.officerPosition,
            formData.message,
            formData.newsletter,
            formData.reCaptchaCode,
            formData.redirectUrl));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="companyName"]', $form).val("");
        $('input[name="occupation"]', $form).val("");
        $('input[name="TaxAgency"]', $form).val("");
        $('input[name="taxidentifier"]', $form).val("");
        $('input[name="officerName"]', $form).val("");
        $('input[name="vatstatus"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="emailConfirmation"]', $form).val("");
        $('input[name="username"]', $form).val("");
        $('input[name="town"]', $form).val("");
        $('select[name="address"]', $form).val("");
        $('input[name="number"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");

        $('input[name="phone"]', $form).val("");
        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");
        $('select[name="storesNumber"]', $form).val("");
        $('input[name="phoneTwo"]', $form).val("");
        $('input[name="mobile"]', $form).val("");

        $('input[name="fax"]', $form).val("");
        $('input[name="siteUrl"]', $form).val("");
        $('input[name="message"]', $form).val("");
        $('input[name="store"]', $form).val("");
        $('input[name="CompanyCategory"]', $form).val("");
        $('input[name="OpeningHours"]', $form).val("");
        $('input[name="area"]', $form).val("");
        $('input[name="prefecture"]', $form).val("");

        $('input[name="officerLastName"]', $form).val("");
        $('input[name="officerPosition"]', $form).val("");

        rf.reset();
    };

    form.updatePasswordBar = function (value) {
        var score = Vendd.Helpers.textStrength(value);

        var $passwordStrength = $('#chkPassLabel, #chkPassText');

        $passwordStrength.removeClass(function (i, css) {
            return (css.match(/(^|\s)level\S+/g) || []).join(' ');
        }).addClass('level' + score);
    };

    $.fn.validationEngine.validations.passwordStrength = Vendd.Validations.passwordStrength;

    var valOpts = {
        companyName: {
            required: 'companyname-required'
        },
        occupation: {
            required: 'occupation-required'
        },
        TaxAgency: {
            required: 'taxagency-required',
        },
        taxidentifier: {
            required: 'taxidentifier-required',
        },
        officerName: {
            required: 'officername-required',
        },
        town: {
            required: 'town-required',
        },
        address: {
            required: 'address-required',
        },
        //number: {
        //    required: 'number-required',
        //},
        postalCode: {
            required: 'postalcode-required',
        },
        phone: {
            required: 'phone-required',
        },

        area: {
            required: 'area-required',
        },
        prefecture: {
            required: 'prefecture-required',
        },
        officerLastName: {
            required: 'officerlastname-required',
        },
        officerPosition: {
            required: 'officerposition-required',
        },

        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        },
        emailConfirmation: {
            required: 'email-confirm-required',
            isEmail: 'email-confirm-invalid',
            match: {
                validator: 'email-confirm-match',
                matchField: 'email'
            }
        },

        password: {
            required: 'password-required',
            passwordStrength: {
                validator: 'password-weak',
                config: {
                    limit: $form.data('pwdstrength')
                }
            }
        },
        passwordConfirmation: {
            required: 'password-confirm-required',
            match: {
                validator: 'password-confirm-match',
                matchField: 'password'
            }
        },
    };

    //add consent validations
    $.each($('.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        valOpts[consentType] = {
            checkboxRequired: consentType + '-required'
        };
    });

    if (!useEmailAsLoginName) {
        valOpts.username = {
            required: 'username-required'
        };

    }


    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');
    
    $.each($('.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el);
        consentType.on('change', function () {
            rf = $form.data('validationEngine');
            rf.validate(consentType.attr('name'));
        });
    });

    $form.on('click', '.js-submit-button', function (e) {

        e.preventDefault();
        e.stopPropagation();

        var val1 = form.validateRecaptcha();
        var val2 = rf.validate();

        if (val1 && val2) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }
        }
    });

    form.checkConsents = function () {
        var data = [];
        var checkboxes = $('.form-row.consent.checkbox');
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Registration Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    };

    $form.on('click', '.js-password-reveal', function (e) {
        e.preventDefault();
        if ($(this).hasClass('shown')) {
            $(this).removeClass('shown').siblings('input').prop('type', 'password');
        } else {
            $(this).addClass('shown').siblings('input').prop('type', 'text');
        }
    });

    $form.on('change', 'select[name]', function (e) {
        var $this = $(this);
        var fieldName = $this.attr('name');
        formData[fieldName] = $("option:selected", $this).text();
        rf = $form.data('validationEngine');
        rf.validate(fieldName);
    });

    $form.on('keyup', 'input[name], textarea[name]', function (e) {

        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        if (fieldName === "password") {
            form.updatePasswordBar($this.val());
        };

        formData[fieldName] = $this.val();
        rf = $form.data('validationEngine');
        rf.validate(fieldName);
    });


    $(".view-terms").fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        maxWidth: 940,
        helpers: {
            overlay: {
                locked: true,
                closeClick: false
            }
        },
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterFailure, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);
    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submit);

});
